<template>
  <section id="conteudo" class="section-shell content-section" data-theme="mesh">
    <div class="section-header" data-reveal>
      <p class="intro">
        Dentro da <span class="word-brand">ZIMA</span>, voc&ecirc; recebe um sistema completo
        <br />
        <span class="intro-sub">&mdash; claro, direto e funcional.</span>
      </p>
    </div>

    <div class="content-grid">
      <article
        v-for="block in blocks"
        :key="block.title"
        class="content-card"
        data-reveal
      >
        <div class="card-top">
          <span class="card-icon" aria-hidden="true"><i :class="block.icon"></i></span>
          <h3 v-html="block.title"></h3>
        </div>
        <div class="card-body">
          <p v-for="(line, lineIndex) in block.details" :key="lineIndex" v-html="line"></p>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup>
const blocks = [
  {
    title: 'Mapa Macro <span class="word-brand">ZIMA</span>',
    icon: 'fas fa-globe-americas',
    details: [
      'Leitura integrada de <strong>BTC, ETH, TOTAL2, DXY, SPX, domin&acirc;ncias, ranges, zonas e ciclos</strong> &mdash; <em>filtrado para o que realmente importa.</em>',
    ],
  },
  {
    title: 'Execu&ccedil;&atilde;o e Risco',
    icon: 'fas fa-crosshairs',
    details: [
      'Crit&eacute;rios claros de entrada, stop, invalida&ccedil;&atilde;o e gest&atilde;o.',
      'Nada de improviso.<br />S&oacute; setups de probabilidade real.',
    ],
  },
  {
    title: 'An&aacute;lises <span class="word-brand">ZIMA</span>',
    icon: 'fas fa-chart-line',
    details: [
      'Leituras pr&oacute;prias e datadas de BTC, ETH e alts &mdash; <em>regime, zonas e inten&ccedil;&atilde;o por tr&aacute;s do movimento.</em>',
      'O porqu&ecirc; vem antes do movimento, n&atilde;o depois.',
    ],
  },
  {
    title: 'Ciclos, Narrativas e Sentimento',
    icon: 'fas fa-wave-square',
    details: [
      'On-chain, agendas macro, narrativas, domin&acirc;ncias e fases sociais do mercado &mdash; <em>explicado em linguagem <span class="word-brand">ZIMA</span>.</em>',
    ],
  },
  {
    title: '<span class="word-brand">ZIMA</span> Mind Engine',
    icon: 'fas fa-brain',
    details: [
      'A forma correta de interpretar manipula&ccedil;&atilde;o e evitar ru&iacute;do. Aqui voc&ecirc; aprende a pensar como quem realmente domina o mercado.',
    ],
  },
  {
    title: 'Painel de An&aacute;lises (<em>curto/m&eacute;dio/longo</em>)',
    icon: 'fas fa-layer-group',
    details: [
      'O fluxo do mercado em tr&ecirc;s horizontes, atualizado.',
      'Onde a tend&ecirc;ncia est&aacute; agora &mdash; <em>e pra onde aponta.</em>',
    ],
  },
];
</script>

<style scoped>
.content-section {
  position: relative;
  border-radius: 18px;
  border: 1px solid rgba(115, 148, 240, 0.16);
  background:
    radial-gradient(circle at 78% 12%, rgba(78, 115, 223, 0.12), transparent 34%),
    linear-gradient(180deg, rgba(10, 13, 24, 0.9), rgba(7, 9, 16, 0.94));
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.content-section,
.content-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.content-section::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(78, 115, 223, 0.05), transparent 26%, transparent 74%, rgba(155, 89, 182, 0.05)),
    radial-gradient(circle at 80% 8%, rgba(78, 115, 223, 0.08), transparent 36%);
  pointer-events: none;
  border-radius: inherit;
}

.section-header .intro {
  margin: 0;
  color: #d8e1f6;
  font-size: clamp(1.2rem, 1.55vw, 1.7rem);
  line-height: 1.42;
  letter-spacing: 0.01em;
  font-weight: 550;
  max-width: 58ch;
  text-wrap: balance;
}

.section-header .intro-sub {
  font-style: italic;
}

.word-brand {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

@keyframes zima-brand-shift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
  margin-top: 18px;
  align-items: stretch;
}

.content-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 18px 16px 16px;
  border: none;
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 0 100%);
  background: linear-gradient(165deg, rgba(12, 15, 26, 0.95), rgba(8, 10, 18, 0.92));
  transition: transform 0.2s ease;
}

.content-card::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  background: linear-gradient(
    160deg,
    rgba(115, 148, 240, 0.42),
    rgba(255, 255, 255, 0.05) 38%,
    rgba(255, 255, 255, 0.04) 62%,
    rgba(155, 89, 182, 0.34)
  );
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  pointer-events: none;
}

.content-card:hover {
  transform: translateY(-3px);
}

.card-top {
  display: flex;
  align-items: center;
  gap: 11px;
  position: relative;
  z-index: 1;
  min-height: 52px;
  margin-bottom: 8px;
}

.card-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.card-icon i {
  font-family: 'Font Awesome 5 Free' !important;
  font-weight: 900;
  font-size: 20px;
  line-height: 1;
  background: linear-gradient(135deg, #7aa2ff 10%, #bd8bff 90%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 0 7px rgba(122, 162, 255, 0.45));
}

.content-card h3 {
  margin: 0;
  color: #e9f0ff;
  font-size: clamp(1.08rem, 1.25vw, 1.32rem);
  line-height: 1.16;
  font-weight: 700;
  letter-spacing: -0.012em;
  text-wrap: balance;
  font-style: normal;
}

.card-body {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 7px;
}

.card-body p {
  margin: 0;
  color: #c6d1e8;
  font-size: clamp(0.95rem, 1.02vw, 1.05rem);
  line-height: 1.48;
  font-style: normal;
  text-wrap: pretty;
}

@media (max-width: 920px) {
  .section-header .intro {
    max-width: none;
    font-size: clamp(1.1rem, 2.8vw, 1.4rem);
  }

  .content-grid {
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 12px;
  }
}

@media (min-width: 1100px) {
  .content-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .content-grid {
    grid-template-columns: 1fr;
  }

  .content-card {
    padding: 16px 14px 14px;
  }

  .card-top {
    min-height: 0;
  }

  .content-card h3 {
    font-size: clamp(1.08rem, 5vw, 1.3rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .word-brand {
    animation: none !important;
  }
}
</style>
